<ui-card
    *ngFor="let group of customDataFieldGroups; let i = index"
    class="profile-card"
    [withMargin]="withMargin"
    role="group"
    [attr.aria-labelledby]="labelId + i"
>
    <div class="profile-card-header">
        <h2 [id]="labelId + i">{{ group.name }}</h2>
        <ui-button
            *ngIf="canEditDataValues && editableFieldsCountPerGroup[group.id] > 0"
            type="link"
            (click)="editFieldGroup(group.name)"
            >{{ 'edit' | appTranslate }}</ui-button
        >
    </div>
    <app-data-field-group-values
        [group]="group"
        [dataFields]="dataFields"
        [dataValues]="dataValues"
    ></app-data-field-group-values>
</ui-card>
